export enum BookingFlowTypeEnum
{
    None = 0,
    Booking = 1,
    CheckIn = 2,
    ManageMyBooking = 3
}
